
import { createClient } from '@supabase/supabase-js';

// Variables de entorno inyectadas por React/Craco
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Faltan credenciales de Supabase en .env.local");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// --- AUTHENTICATION HELPERS ---

export const signInWithGoogle = async () => {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    // Usa la configuración del dashboard de Supabase (URL Configuration)
  });
  return { data, error };
};

export const signInWithFacebook = async () => {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'facebook',
    // Usa la configuración del dashboard
  });
  return { data, error };
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  return { error };
};

// Helper to get image URL
export const getImageUrl = (path: string) => {
  if (!path) return 'https://via.placeholder.com/400';
  if (path.startsWith('http')) return path;
  const { data } = supabase.storage.from('productos').getPublicUrl(path);
  return data.publicUrl;
};
